export const DEFAULT_LANGUAGE = 'en';
export const DEFAULT_TIMEZONE = 'America/Los_Angeles';
export const DEFAULT_LOCALE = 'en_US';
